/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

/** Runtime/model-facing override name. */
export const RUNTIME_TOOL_SEARCH_TOOL_NAME = 'tool_search_tool';

/** Client/workbench-facing tool reference name. */
export const CLIENT_TOOL_SEARCH_REFERENCE_NAME = 'toolSearch';
